import { Flex, Text } from '@podiumhq/design-system';
import PodiumLogo from 'components/PodiumLogo';
import PropTypes from 'prop-types';

const PaymentReceived = ({ customerName, amount }) => (
  <Flex
    w="287px"
    p="16px"
    borderRadius="24px"
    bg="silver.lightest"
    borderBottomLeftRadius="0px"
    alignItems="center"
  >
    <Flex
      width="48px"
      height="48px"
      bg="black.base"
      alignItems="center"
      justifyContent="center"
      borderRadius="14px"
      mr="16px"
    >
      <PodiumLogo icon={true} invert={true} maxWidth="17px" />
    </Flex>
    <Flex flexDir="column">
      <Text color="black.base" fontWeight="semibold" fontSize="md">
        {customerName} paid ${amount}
      </Text>
      <Text color="grey.light" fontSize="sm" mt="5px">
        Text payment
      </Text>
    </Flex>
  </Flex>
);

PaymentReceived.propTypes = {
  customerName: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
};

export default PaymentReceived;
